export default __webpack_public_path__ + "static/limewire-7fd7e57df38a952921183c80b344c7fd.png";